export default __webpack_public_path__ + "static/media/kitchen3-afterF-1440w.6128a495.webp";